import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Sidebar from './Components/SideBar';
import { SidebarProvider } from './SidebarContext';
import AllUsers from './Components/AllUsers';
import Articles from './Components/Articles';
import ContactTable from './Components/ContactTable';
import PaymentHistoryTable from './Components/PaymentHistoryTable';
import Login from './Components/Login';
import ResetPassword from './Components/ResetPassword';
import Plan from './Components/Plan';
import News from './Components/News';
import Coupon from './Components/Coupon';
import { ToastContainer } from 'react-toastify';
import CouponUsage from './Components/CouponUsage';
import Volume from './Components/Volume';
import Issues from './Components/Issues';
import VideoUploadForm from './Components/VideoForm/VideoDetail';
import Content from './Components/Content';
import Event from './Components/Event/Event';
import Analytics from './Components/Analytics/Analytics';
import SingleAnalytics from './Components/Analytics/SingeAnalytics';
import BoostHistoryTable from './Components/Boost/BoostHistory';
import Earning from './Components/Earning/Earning';
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';

export const isUserLoggedIn = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT payload
    const exp = payload.exp * 1000; // exp is in seconds, convert to ms
    return Date.now() < exp; // true = valid, false = expired
  } catch (err) {
    return false; // invalid token
  }
};
const App = () => {
  const location=useLocation()
  const navigate = useNavigate();

  const isLoggedIn = isUserLoggedIn();
  // console.log(isLoggedIn)
  // redirect if token expired
  useEffect(() => {
    if (!isLoggedIn) {
      localStorage.removeItem("token");
      navigate("/login");
    }
  }, [location, isLoggedIn, navigate]);

  return (
    <SidebarProvider>
      <div className="app-container">
        {/* Show sidebar if logged in */}
        {isLoggedIn && <Sidebar />}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="main-content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />

            <Route path="/" element={isLoggedIn ? <Content /> : <Navigate to="/login" />} />
            <Route path="/analytics" element={isLoggedIn ? <Analytics /> : <Navigate to="/login" />} />
            <Route path="/analytics/:id/:videoId" element={isLoggedIn ? <SingleAnalytics /> : <Navigate to="/login" />} />
            <Route path="/earning" element={isLoggedIn ? <Earning /> : <Navigate to="/login" />} />
            {/* Catch-all route */}
            <Route path="*" element={<Navigate to={isLoggedIn ? "/" : "/login"} />} />
          </Routes>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </SidebarProvider>
  );
};

export default App;
